{% block sw_data_grid_columns_render_router_link %}
    <router-link
        v-if="column.routerLink && column.routerLinkIdProperty && item[column.routerLinkIdProperty] !== null"
        class="sw-data-grid__cell-value"
        :to="{ name: column.routerLink, params: { id: item[column.routerLinkIdProperty] } }"
    >
        {{ renderColumn(item, column) }}
    </router-link>

    <router-link
        v-else-if="column.routerLink"
        class="sw-data-grid__cell-value"
        :to="{ name: column.routerLink, params: { id: item.id } }"
    >
        {{ renderColumn(item, column) }}
    </router-link>
{% endblock %}